import './App.css';
import AppRoute from './utility/AppRoute';
import AxiosInterceptorSetup from './modules/Admin/services/AxiosInterceptorSetup';
import SessionBootstrap from './shared/SessionBootstrap/SessionBootstrap';
import Privacy from './shared/Privacy/Privacy';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from './modules/Admin/components/Dashboard/Dashboard';
import SearchResults from './shared/Search/SearchResults';
import About from './shared/About/About';
import LoginForm from './shared/Login/LoginForm';
import SupportForm from './shared/Support/SupportForm';
import Leads from './modules/Admin/components/Lead/Leads';
import AddLead from './modules/Admin/components/Lead/AddLead';
import LeadsAssigned from './modules/Admin/components/LeadsAssigned/LeadsAssigned';
import AddLeadsAssigned from './modules/Admin/components/LeadsAssigned/AddLeadsAssigned';
import EditLead from './modules/Admin/components/Lead/EditLead';
import ExcelReader from './modules/Admin/components/Lead/ExcelReader';
import Unauthorized from './shared/Unauthorized/Unauthorized';
import ProtectedRoute from './shared/ProtectedRoute/ProtectedRoute';
import EditLeadAssigned from './modules/Admin/components/LeadsAssigned/EditLeadAssigned';
import LeadDetails from './modules/Admin/components/Lead/LeadDetails';
import PrintLead from './modules/Admin/components/Lead/PrintLead';
import PendingFollowUps from './modules/Admin/components/LeadsAssigned/PendingFollowUps';
import AddUser from './modules/Admin/components/Auth/AddUser';
import RegisterUser from './modules/Admin/components/Auth/RegisterUser';
import EditUser from './modules/Admin/components/Auth/EditUser';
import LogOut from './modules/Admin/components/Auth/LogOut';
import Clients from './modules/SuperAdmin/components/Client/Clients';
import FilterDataDashboardList from './modules/Admin/components/LeadsAssigned/FilterDataDashboardList';
import FilterDataEmployee from './modules/Admin/components/LeadsAssigned/FilterDataEmployee';
import FilterLeadsDashboard from './modules/Admin/components/Lead/FilterLeadsDashboard';
import TermsAndConditions from './shared/TermsAndConditions/TermsAndConditions';
import FilteredData from './modules/Admin/components/LeadsAssigned/FilterData';
import AddClient from './modules/SuperAdmin/components/AddClient';
import EditClient from './modules/SuperAdmin/components/Client/EditClient';
import IntegrationSettings from './modules/SuperAdmin/components/Integration/IntegrationSettings';
import AddClientUser from './modules/SuperAdmin/components/ClientUser/AddClientUser';
import EditClientUser from './modules/SuperAdmin/components/ClientUser/EditClientUser';
import EditFBIntegration from './modules/SuperAdmin/components/EditFBIntegration';
import Property from './modules/Admin/components/PropertyListing/Property';
import AddProperty from './modules/Admin/components/PropertyListing/AddProperty';
import EditProperty from './modules/Admin/components/PropertyListing/EditProperty';
import EditSubscription from './modules/SuperAdmin/components/Subscription/EditSubscription';
import SubscriptionPlansSettings from './modules/SuperAdmin/components/Subscription/SubscriptionPlansSettings';
import KanbanPipeline from './modules/Admin/components/LeadsAssigned/KanbanPipeline';
import PipelineStageManager from './modules/Admin/components/LeadsAssigned/PipelineStageManager';
import LeadCaptureForm from './modules/Public/LeadCaptureForm';
import ProductLanding from './shared/Public/ProductLanding';
import ProductContact from './shared/Public/ProductContact';
import Reports from './modules/Admin/components/Dashboard/Reports';
import MyAttendance from './modules/Admin/components/Attendance/MyAttendance';
import TeamAttendance from './modules/Admin/components/Attendance/TeamAttendance';
import PropertyDetail from './modules/Admin/components/PropertyListing/PropertyDetail';
import BookingForm from './modules/Admin/components/PropertyListing/BookingForm';
import Buyers from './modules/Admin/components/Buyers/Buyers';
import BuyerDetail from './modules/Admin/components/Buyers/BuyerDetail';
import Builders from './modules/Admin/components/Builders/Builders';
import AddBuilder from './modules/Admin/components/Builders/AddBuilder';
import EditBuilder from './modules/Admin/components/Builders/EditBuilder';
import WorkspaceSettings from './modules/Admin/components/Settings/WorkspaceSettings';
import SubscriptionInactive from './shared/SubscriptionInactive/SubscriptionInactive';

const Roles = Object.freeze({
  SuperAdmin: 1,
  Admin: 2,
  Employee: 4,
});

function App() {
  return (
    <SessionBootstrap>
    <AxiosInterceptorSetup>
    <div>
      <Router >
      <Routes>

      <Route path="/login" element={<LoginForm></LoginForm>} />
      <Route path="/subscription-inactive" element={<SubscriptionInactive />} />

      <Route path="/home" element={<ProductLanding />} />
      <Route path="/contact-sales" element={<ProductContact />} />
  
      <Route path="/" element={<AppRoute><Dashboard/></AppRoute>} />

      <Route path="/unauthorized" element={<AppRoute><Unauthorized/></AppRoute>} />

      <Route path="/dashboard" element={
          <AppRoute><Dashboard /></AppRoute>
        } />


      <Route path="/buyers/:id" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><BuyerDetail /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/buyers" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><Buyers /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/pendingfollowups" element={
                <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
                  <AppRoute><PendingFollowUps /></AppRoute>
                </ProtectedRoute>
              } />


        <Route path="/printlead" element={
                  <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
                    <AppRoute><PrintLead /></AppRoute>
                  </ProtectedRoute>
                } />


        <Route path="/about" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><About /></AppRoute>
          </ProtectedRoute>
        } />

      <Route path="/privacy" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
          <AppRoute><Privacy /></AppRoute>
        </ProtectedRoute>
      } /> 

        <Route path="/termsandconditions" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
          <AppRoute><TermsAndConditions /></AppRoute>
        </ProtectedRoute>
      } />   

       <Route path="/registeruser" element={
          <ProtectedRoute allowedRoles={[Roles.Admin, Roles.SuperAdmin]}>
            <AppRoute><RegisterUser /></AppRoute>
          </ProtectedRoute>
        } />

      <Route path="/client" element={
        <ProtectedRoute allowedRoles={[ Roles.SuperAdmin]}>
          <AppRoute><Clients /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/addClient" element={
              <ProtectedRoute allowedRoles={[ Roles.SuperAdmin]}>
                <AppRoute><AddClient /></AppRoute>
              </ProtectedRoute>
            }
             />

      <Route path="/editClient/:id" element={
                    <ProtectedRoute allowedRoles={[ Roles.SuperAdmin]}>
                      <AppRoute><EditClient /></AppRoute>
                    </ProtectedRoute>
                  } />
                  
      <Route path="/editClient" element={
                    <ProtectedRoute allowedRoles={[ Roles.SuperAdmin]}>
                      <AppRoute><EditClient /></AppRoute>
                    </ProtectedRoute>
                  } />


    <Route path="/integrationsettings" element={
                        <ProtectedRoute allowedRoles={[ Roles.SuperAdmin]}>
                          <AppRoute><IntegrationSettings /></AppRoute>
                        </ProtectedRoute>
                      } />

      <Route path="/subscriptionplans" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin]}>
          <AppRoute><SubscriptionPlansSettings /></AppRoute>
        </ProtectedRoute>
      } />

        <Route path="/adduser" element={
          <ProtectedRoute allowedRoles={[Roles.Admin, Roles.SuperAdmin]}>
          <AppRoute><AddUser /></AppRoute>
          </ProtectedRoute>
        } />

         <Route path="/edituser/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><EditUser /></AppRoute>
          </ProtectedRoute>
        } />

         <Route path="/quicksupport" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><SupportForm /></AppRoute>
          </ProtectedRoute>
        } />

         <Route path="/leads" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
            <AppRoute><Leads /></AppRoute>
          </ProtectedRoute>
        } />

        <Route path="/importLeads" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><ExcelReader /></AppRoute>
          </ProtectedRoute>
        } />

      <Route path="/editlead/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><EditLead /></AppRoute>
          </ProtectedRoute>
        } />

         <Route path="/editfbintegration/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><EditFBIntegration /></AppRoute>
          </ProtectedRoute>
        } />

<Route path="/editsubscription/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin]}>
            <AppRoute><EditSubscription /></AppRoute>
          </ProtectedRoute>
        } />

        <Route path="/addlead" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><AddLead /></AppRoute>
          </ProtectedRoute>
        } />

          <Route path="/leadassigned" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><LeadsAssigned /></AppRoute>
          </ProtectedRoute>
        } />


      <Route path="/filteredDashboarddata/:employeeId/:fromDateParam/:toDateParam" element={
                <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
                  <AppRoute><FilterDataDashboardList /></AppRoute>
                </ProtectedRoute>
              } />

            <Route path="/filteredLeads/:employeeId/:fromDateParam/:toDateParam" element={
                            <ProtectedRoute allowedRoles={[ Roles.SuperAdmin, Roles.Admin]}>
                              <AppRoute><FilterLeadsDashboard /></AppRoute>
                            </ProtectedRoute>
                          } />

            <Route path="/filteredDataEmployee/:employeeId/:fromDateParam/:toDateParam/:LeadStatusId" element={
                            <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
                              <AppRoute><FilterDataEmployee /></AppRoute>
                            </ProtectedRoute>
                          } />

            <Route path="/filterdata" element={
                            <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
                              <AppRoute><FilteredData /></AppRoute>
                            </ProtectedRoute>
                          } />

        <Route path="/addleadsassigned" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
            <AppRoute><AddLeadsAssigned /></AppRoute>
          </ProtectedRoute>
        } />

<Route path="/addproperty" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
            <AppRoute><AddProperty /></AppRoute>
          </ProtectedRoute>
        } />

              <Route path="/editleadassigned/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><EditLeadAssigned /></AppRoute>
          </ProtectedRoute>
        } />

<Route path="/editproperty/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
            <AppRoute><EditProperty /></AppRoute>
          </ProtectedRoute>
        } />

        <Route path="/search" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><SearchResults /></AppRoute>
          </ProtectedRoute>
        } />

        <Route path="/leads/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
            <AppRoute><LeadDetails /></AppRoute>
          </ProtectedRoute>
        } />
        <Route path="/addclientuser" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin]}>
            <AppRoute><AddClientUser /></AppRoute>
          </ProtectedRoute>
        } />
        <Route path="/editclientuser/:id" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin]}>
            <AppRoute><EditClientUser /></AppRoute>
          </ProtectedRoute>
        } />

      <Route path="/kanban" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
          <AppRoute><KanbanPipeline /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/pipeline-stages" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><PipelineStageManager /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/reports" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><Reports /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/property/:id" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
          <AppRoute><PropertyDetail /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/property/:id/book" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><BookingForm /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/attendance" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin, Roles.Employee]}>
          <AppRoute><MyAttendance /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/team-attendance" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><TeamAttendance /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/settings" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><WorkspaceSettings /></AppRoute>
        </ProtectedRoute>
      } />

      {/* Public lead-capture form — no auth, embeddable via iframe: /lead-form/:clientId */}
      <Route path="/lead-form/:clientId" element={<LeadCaptureForm />} />
      <Route path="/lead-form" element={<LeadCaptureForm />} />

      <Route path="/logout" element={<AppRoute><LogOut /></AppRoute>} />
     
      <Route path="/builders" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><Builders /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/addbuilder" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><AddBuilder /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/editbuilder/:id" element={
        <ProtectedRoute allowedRoles={[Roles.SuperAdmin, Roles.Admin]}>
          <AppRoute><EditBuilder /></AppRoute>
        </ProtectedRoute>
      } />

      <Route path="/propertylisting" element={
          <ProtectedRoute allowedRoles={[Roles.SuperAdmin,Roles.Admin]}>
            <AppRoute><Property /></AppRoute>
          </ProtectedRoute>
        } />

    </Routes>
  </Router>
    </div>
    </AxiosInterceptorSetup>
    </SessionBootstrap>
  );
}

export default App;
